import React from 'react';
import { View, TouchableOpacity, Text, StyleSheet } from 'react-native';
import { TableFilters } from '@/components';
import { TaskFiltersErrorBoundary } from '@/components/admin/tasks/TaskFiltersErrorBoundary';
import { ADMIN_COLORS } from '@/constants/admin';
import { IFilterModel, ISortModel } from '@/types/admin/dataTable';

interface TasksFiltersHeaderProps {
  view: 'list' | 'archived';
  onChangeView: (v: 'list' | 'archived') => void;
  columns: any[];
  searchQuery: string;
  onSearchChange: (q: string) => void;
  filterModel: any;
  onFilterChange: (m: IFilterModel) => void;
  sortModel: ISortModel[];
  onSortChange: (m: ISortModel[]) => void;
  headerRight?: React.ReactNode;
  onRetry: () => void;
}

export const TasksFiltersHeader: React.FC<TasksFiltersHeaderProps> = ({
  view,
  onChangeView,
  columns,
  searchQuery,
  onSearchChange,
  filterModel,
  onFilterChange,
  sortModel,
  onSortChange,
  headerRight,
  onRetry,
}) => {
  return (
    <View style={styles.container}>
      <View style={styles.tabs}>
        <TouchableOpacity
          style={[styles.tab, view === 'list' && styles.tabActive]}
          onPress={() => onChangeView('list')}
          activeOpacity={0.8}
        >
          <Text style={[styles.tabText, view === 'list' && styles.tabTextActive]}>Tasks</Text>
        </TouchableOpacity>
        <TouchableOpacity
          style={[styles.tab, view === 'archived' && styles.tabActive]}
          onPress={() => onChangeView('archived')}
          activeOpacity={0.8}
        >
          <Text style={[styles.tabText, view === 'archived' && styles.tabTextActive]}>Archived</Text>
        </TouchableOpacity>
      </View>

      <TaskFiltersErrorBoundary onRetry={onRetry}>
        <TableFilters
          columns={columns}
          searchQuery={searchQuery}
          onSearchChange={onSearchChange}
          filterModel={filterModel}
          onFilterChange={onFilterChange}
          sortModel={sortModel}
          onSortChange={onSortChange}
          headerRight={headerRight}
        />
      </TaskFiltersErrorBoundary>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    marginBottom: 12,
  },
  tabs: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: ADMIN_COLORS.BACKGROUND.SECONDARY,
    borderRadius: 8,
    padding: 4,
    marginBottom: 12,
  },
  tab: {
    flex: 1,
    paddingVertical: 8,
    alignItems: 'center',
    borderRadius: 6,
  },
  tabActive: {
    backgroundColor: ADMIN_COLORS.PRIMARY,
  },
  tabText: {
    fontSize: 14,
    color: ADMIN_COLORS.TEXT_SECONDARY,
    fontWeight: '500',
  },
  tabTextActive: {
    color: ADMIN_COLORS.TEXT_PRIMARY,
  },
});


